import { render, staticRenderFns } from "./OpportunityClosingReasonModal.vue?vue&type=template&id=6a2bcc8d&scoped=true&"
import script from "./OpportunityClosingReasonModal.vue?vue&type=script&lang=js&"
export * from "./OpportunityClosingReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2bcc8d",
  null
  
)

export default component.exports